import { Component, Input, OnInit } from '@angular/core';
import * as Parse from 'parse';

interface Zestimate {
    amount: string;
    thirtyDayChange: string | number;
    range: {
        low: string,
        high: string
    };
    lastUpdated: string;
}

interface ZillowInfo {
    sellZestimate: Zestimate;
    rentZestimate: Zestimate;
}

@Component({
    selector: 'app-zillow-box',
    templateUrl: './zillow-box.component.html',
    styleUrls: ['./zillow-box.component.scss']
})
export class ZillowBoxComponent implements OnInit {
    @Input() property?: Parse.Object;
    @Input() lastUpdated?: Date;
    @Input() showPricePercentage?: boolean;
    @Input() hideIfNoData?: boolean;

    public percentBelowZestimate: string = '';
    public zillowError: boolean = false;
    public zillowInfo: ZillowInfo | null = null;

    constructor() {
    }

    ngOnInit() {
    }

}
